import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ArtiService, ArtiType } from './arti.service';
import { AccordionVM } from '../accordion/accordion.model';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { InitScripts } from '../app.constants';
import { MetamanagerService } from '../metamanager.service';

@Component({
  selector: 'app-arti',
  templateUrl: './arti.component.html',
  styleUrls: ['./arti.component.css']
})
export class ArtiComponent implements OnInit, AfterViewInit {
  atype: ArtiType = ArtiType.arti;
  sutras = new BehaviorSubject<AccordionVM[]>([]);
  title: any;
  isProgress = new BehaviorSubject<boolean>(true);

  constructor(private artiService: ArtiService, private route: ActivatedRoute, private router: Router,
    private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
  }

  ngOnInit(): void {
    this.metaManager.updateMetaTitle("Mahanubhav Arti | Bhajan | Prarthana | Ovi | Abhanga | sarvadhnya.com",
      "Andriod Apps - Easy access to Mahanubhav Arti, Bhajan, Prarthana, Ovi, Abhanga. Read online, download for free, Arti book download, bhanjan book download",
      "Mahanubhav Arti, Mahanubhav Bhajan, Mahanubhav Prarthana, Mahanubhav Ovi, Mahanubhav Abhanga, Mahanubhav Sahitya, Arti book download, bhanjan book download");

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.isProgress.next(true)
    const type = this.route.snapshot.paramMap.get('atype')?.toString();
    this.atype = ArtiType[type as keyof typeof ArtiType];

    if (type == "arti")
      this.title = "आरती";
    else if (type == "bhajan")
      this.title = "भजन";
    else if (type == "prarthana")
      this.title = "प्रार्थना";
    else if (type == "ovi")
      this.title = "ओव्या";
    else if (type == "abhanga")
      this.title = "अभंग";

    var v = this.artiService.get(this.atype).subscribe(result => {
      var v = this.sutras.getValue().concat(result);
      this.sutras.next(v);
      this.isProgress.next(false);
    });

  }

  ngAfterViewInit(): void {
    Array.from(document.getElementsByClassName("nav-link")).forEach(element => {
      element.classList.remove("active");
      var v = element as HTMLAnchorElement;
      if (v.href.endsWith(ArtiType[this.atype].toString()))
        element.classList.add("active");
    });
  }

  
}

